<!-- Inclusions & Exclusions -->
<div class="card border-2 mr-0 my-3 bg-alt" style="border-color:#2d313a;">
  <!-- Inclusions -->
  <header class="card-header border-0 position-relative px-md-5 pt-4 bg-alt">
    <h2 class="h4 mb-1 block-border-s pl-3">Included on all Kopa Tours {{itineraryTypeString}} Itineraries:</h2>
  </header>
  <div class="card-body pt-0 px-md-5 pb-5">
    <ul class="list-group list-group-flush list-group-borderless">
      <ng-content select="[inclusions]"></ng-content>
    </ul>
  </div>
  <!-- End Inclusions -->

  <!-- Exclusions -->
  <header class="card-header border-0 position-relative px-md-5 pt-4 bg-alt">
    <h2 class="h4 mb-1 block-border-d pl-3">Not included on Kopa Tours {{itineraryTypeString}} Itineraries:</h2>
  </header>
  <div class="card-body pt-0 px-5 pb-5">
    <ul class="list-group list-group-flush list-group-borderless">
      <ng-content select="[exclusions]"></ng-content>
    </ul>
  </div>
  <!-- End Exclusions -->

  <!-- Additions -->
  <div [hidden]="!combowrapper.hasChildNodes()">
    <header class="card-header border-0 position-relative px-md-5 pt-4 bg-alt">
      <h2 class="h4 mb-1 block-border-w pl-3">Make it a combo:</h2>
    </header>
    <div class="card-body pt-0 px-5 pb-5">
      <ul class="combo-wrapper list-group list-group-flush list-group-borderless">
        <span #combowrapper>
          <ng-content select="[combos]"></ng-content>
        </span>
      </ul>
    </div>
  </div>
  <!-- End Additions -->
</div>
<!-- End Inclusions & Exclusions -->
